import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { NumericFormat } from 'react-number-format';
import { api } from '../../components/api/api';
import { Alert, AlertErro } from '../../util/Alertas';

class ModalMateriaPrima extends Component {
    constructor(props) {
        super(props);
        this.state = this.initialState;
        this.novo = () => {
            this.setState({
                ...this.initialState,
                show: true
            });
        }
        this.edit = ({ id, nome, valorUn, quantidade }, entrada = false, saida = false) => {
            this.setState({
                id,
                nome,
                valor: valorUn,
                quantidade: entrada || saida ? '' : quantidade,
                isEdit: true,
                show: true,
                entrada,
                saida
            });
        }
    }

    initialState = {
        id: 0,
        show: false,
        isEdit: false,
        nome: '',
        valor: '',
        quantidade: '',
        entrada: false,
        saida: false
    }

    handleValueChange = (values) => {
        const { floatValue } = values;
        this.setState({ valor: floatValue });
    };

    onCloseModal = () => {
        this.setState(this.initialState);
    }

    onChangeInputValue = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    };

    Disabled = () => {
        const { entrada, saida } = this.state;
        return entrada || saida
    }

    render() {
        const { Reload } = this.props;
        const { id, show, isEdit, nome, valor, quantidade, saida, entrada } = this.state;

        const onSubmit = () => {
            if (!entrada && !saida) {
                api.post(`api/MateriaPrima${isEdit ? '/Edit/' + id : ''}`, {
                    nome,
                    valorUn: valor,
                    quantidade
                }, res => {
                    Alert("Materia Prima adicionada com sucesso!", true)
                    Reload();
                    this.onCloseModal();
                }, err => AlertErro(err))
            } else {
                api.post(`api/MateriaPrima${entrada && !saida ? '/Entrada' : '/Saida'}/${id}`, { quantidade: parseInt(quantidade) }, res => {
                    Alert("Quantidade atualizada com sucesso!", true)
                    Reload();
                    this.onCloseModal();
                }, err => AlertErro(err))
            }
        }

        if (!show) return;

        return (
            <Modal show={show}>
                <form onSubmit={e => { e.preventDefault(); onSubmit(); this.onCloseModal() }}>
                    <Modal.Body>
                        {!entrada && !saida && <>
                            <label>Nome</label>
                            <input
                                required
                                onChange={this.onChangeInputValue}
                                name='nome'
                                value={nome}
                                className='form-control'
                                type="text"
                                disabled={this.Disabled()}
                            />
                            <label>Valor Un.</label>
                            <NumericFormat
                                id="valor"
                                value={valor}
                                thousandSeparator="."
                                decimalSeparator=","
                                prefix="R$ "
                                decimalScale={2}
                                onValueChange={this.handleValueChange}
                                placeholder="Digite o valor"
                                className="form-control"
                                disabled={this.Disabled()}
                            />
                        </>}
                        {!entrada && !saida && <label>Quantidade Em Estoque</label>}
                        {entrada && !saida && <label>Selecione a quantidade de Entrada</label>}
                        {!entrada && saida && <label>Selecione a quantidade de Saída</label>}
                        <input
                            onChange={this.onChangeInputValue}
                            name='quantidade'
                            value={quantidade}
                            className='form-control'
                            type="number"
                            min={1}
                            required
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='btn btn-danger' onClick={() => this.onCloseModal()}>Fechar</button>
                        <button className='btn btn-primary' type='submit'>{isEdit ? 'Atualizar' : 'Adicionar'}</button>
                    </Modal.Footer>
                </form>
            </Modal >
        );
    }
}

export default ModalMateriaPrima;